import { Request } from '../../../../httpClient/serverApi/requests/Request';

export interface ICreateLocalServerUserWithoutPasswordParams {
  username: string;
  displayName: string;
  email: string;
}

export interface ICreateLocalServerUserResult {
}

export class CreateLocalServerUserWithoutPasswordRequest extends Request<ICreateLocalServerUserWithoutPasswordParams, ICreateLocalServerUserResult> {
  constructor(params: ICreateLocalServerUserWithoutPasswordParams) {
    super('createLocalServerUserWithoutPassword', params);
  }
}
